<div class="search-container">
  <form [formGroup]="searchForm">
    <div class="search-input-wrapper">
      <i class="search-icon icon-search"></i>
      <input 
        type="text" 
        class="search-input"
        #searchInput
        [formControl]="searchControl"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        [placeholder]="'access_control.dialog.search_user' | translate" 
        aria-label="Search users"
      />
      <i class="dropdown-icon icon-chevron-down" 
         *ngIf="!isLoading" 
         (click)="toggleDropdown()"></i>
      <mat-spinner 
         class="loading-spinner" 
         *ngIf="isLoading"
         diameter="20"></mat-spinner>
    </div>
    
    <div class="dropdown-menu" 
         [class.show]="isDropdownOpen && (availableUsers.length > 0 || isLoading || (searchControl.value && searchControl.value.trim().length > 0))"
         (mouseenter)="onDropdownMouseEnter()"
         (mouseleave)="onDropdownMouseLeave()"
         (click)="onDropdownClick($event)">
      
      <!-- Create New Option -->
      <div class="dropdown-item create-option" 
           *ngIf="showCreateOption && searchControl.value && searchControl.value.trim().length > 0"
           (click)="onCreateOptionClick()">
           <div class="user-avatar create-avatar">
               <div class="default-avatar">
                   <mat-icon>person_add</mat-icon>
               </div>
           </div>
           <div class="user-info">
               <div class="user-name">{{ 'request_v2.create-request-dialog.create-new-account' | translate }}</div>
               <div class="user-email">{{ 'request_v2.create-request-dialog.register-new-citizen' | translate }}</div>
           </div>
      </div>

      <!-- Search Results - Available Users (some may show as assigned) -->
      <div class="available-users-section" *ngIf="availableUsers.length > 0">
        <div class="dropdown-item" 
             *ngFor="let user of availableUsers; trackBy: trackByUserId"
             [class.disabled]="user.isDisabled"
             [class.assigned]="user.isAssigned"
             (click)="toggleUserSelection(user)">
          
          <div class="selection-wrapper" *ngIf="mode === 'multi' || (mode === 'single' && showRadio)">
          
         <div class="checkbox-wrapper" *ngIf="mode === 'multi'">
            <input 
              type="checkbox" 
              [checked]="isUserSelected(user)"
              [disabled]="user.isDisabled"
              (change)="toggleUserSelection(user)"
              (click)="$event.stopPropagation()"
            />
            <div class="custom-checkbox" 
                 [class.checked]="isUserSelected(user)"
                 [class.disabled]="user.isDisabled">
              <i class="check-icon" *ngIf="isUserSelected(user)">✓</i>
            </div>
          </div>

          <!-- Radio button for single mode -->
          <div class="radio-wrapper" *ngIf="mode === 'single' && showRadio">
            <input 
              type="radio" 
              [checked]="user.selected"
              [disabled]="user.isDisabled"
              (change)="toggleUserSelection(user)"
              (click)="$event.stopPropagation()"
              [name]="'user-selection'"
            />
            <div class="custom-radio" [class.checked]="isUserSelected(user)" [class.disabled]="user.isDisabled"></div>
              <div class="radio-dot" *ngIf="isUserSelected(user)"></div>
            </div>
        </div>

          <div class="user-avatar">
            <img [src]="user.avatar" [alt]="user.name + ' avatar'" />
          </div>
          <div class="user-info">
            <div class="user-name">{{ user.name }}</div>
            <div class="user-email">{{ user.email }}</div>
            <div class="user-phone" *ngIf="user.phone">{{ user.phone }}</div>

          </div>
          <!-- Show assigned badge if user is assigned to this role -->
          <span class="assigned-badge" *ngIf="user.isAssigned">{{ 'access_control.dialog.assigned' | translate }}</span>
        </div>
      </div>

      <!-- No Results -->
      <div class="dropdown-item no-results" *ngIf="availableUsers.length === 0 && searchControl.value">
        <i class="icon-search-off"></i>
        <span>{{ 'access_control.dialog.no_users_found' | translate }}</span>
      </div>

    </div>
  </form>
</div>